import { render } from "./WazzupMail.vue?vue&type=template&id=0de49922&scoped=true"
import script from "./WazzupMail.vue?vue&type=script&lang=js"
export * from "./WazzupMail.vue?vue&type=script&lang=js"

import "./WazzupMail.vue?vue&type=style&index=0&id=0de49922&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de49922"]])

export default __exports__